import { render, staticRenderFns } from "./NotifError.vue?vue&type=template&id=59477e64&scoped=true&"
import script from "./NotifError.vue?vue&type=script&lang=js&"
export * from "./NotifError.vue?vue&type=script&lang=js&"
import style0 from "./NotifError.vue?vue&type=style&index=0&id=59477e64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59477e64",
  null
  
)

export default component.exports